import React, { useState, useCallback, useEffect, useContext } from "react";
import style from "./Tab4.module.scss";
import { v4 } from "uuid";
import { wait } from "../../comm/comm";
import * as YStyled from "../../Styleds";
import FriendInfo from "../../comm/global/components/FriendInfo";
import { GameContext } from "../../GameContext";
import apiManager from '../../ApiManager';
const Tab4 = ({ loginData, set_loginData, addModalType, set_menuVisiable, set_bottomSheetOpen }) => {
  const { userData, set_userData } = useContext(GameContext);
  const [breath, set_breath] = useState(77);
  const [badges, set_badges] = useState([]);
  const [currentVo, set_currentVo] = useState(null);
  const [notifications, set_notifications] = useState([]);
  const [invitations, set_invitations] = useState([]);

  useEffect(() => {
    apiManager.fetchGet(`auth/notifications`, {}, 0).then(notifications => {
        set_notifications(notifications.reverse());
    });
    /* apiManager.fetchGet(`user/${userData.users_id}/badges`, {}, 0).then(badges => {
      loadData(badges ?? []);
    }); */
    apiManager.fetchGet(`event-invitations`, {}, 0).then(res => {
      set_invitations(res);
    })
  }, [])
  const loadData = async (badges) => {
    try {
      const path = `./badge.json`;
      const response = await fetch(path);
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      const jsonData = await response.json();
      console.log("jsonData", jsonData)
      const _badage = [];
      badges.forEach(_v => {
        const obj = jsonData.find(v => v.id === _v.badges_code);
        obj.times = _v.badges_count;
        _badage.push(obj);
      })
      set_badges(_badage);
    } catch (error) {
      console.log(error)
    }
  };
  return (
    <div className={style.app}>
      <YStyled.Row style={{ width: "100%", marginTop: "1rem" }}>
        <YStyled.Span size={22} fontWeight={700} color="#71532D80">Welcome!</YStyled.Span>
        <YStyled.Row gap=".6rem" style={{ width: "auto" }}>
          <div style={{ position: "relative" }}>
            <img src="./assets/ui/notice.svg" onClick={e => {
                addModalType({ cls: "Notice" })
            }} />
            {notifications.length > 0 &&
              <div className={style.redPoint} style={{ top: "1px", right: "1px" }}></div>
            }
          </div>
          <img src="./assets/ui/more.svg" onClick={e => {
            addModalType({ cls: "Setting" })
          }} />
        </YStyled.Row>
      </YStyled.Row>
      <YStyled.Row style={{ width: "100%", marginTop: "2rem" }}>
        <FriendInfo user={{ user_id: userData.users_username, user_name: userData.users_name, user_avatar: userData.users_avatar }} type={5} />
        <div className={style.handup} onClick={e => {
          apiManager.fetchPut(`auth/take-me`, {
            "users_take_me_status": userData.users_take_me_status ? 0 : 1
          }, 0).then(res => {
            console.log(res);
            set_userData(res);
          })
        }}>
          <img src={(userData.users_take_me_status) ? "./assets/ui/handup.png" : "./assets/ui/handdown.png"} />
        </div>

      </YStyled.Row>
      {/* <div className={style.breath}>
        <div className={style.bar}>
          <div className={style.progress} style={{ width: `${breath}%` }} />
          <div className={style.dottedLine} style={{ left: "25%" }} />
          <div className={style.dottedLine} style={{ left: "75%" }} />
          <YStyled.Span size={12} color="#71532D" fontFamily="SF Pro" className={style.tipNumber} style={{ left: "0%" }}>0</YStyled.Span>
          <YStyled.Span size={12} color="#71532D" fontFamily="SF Pro" className={style.tipNumber} style={{ left: "25%", transform: "translateX(-50%)" }}>25</YStyled.Span>
          <YStyled.Span size={12} color="#71532D" fontFamily="SF Pro" className={style.tipNumber} style={{ left: "75%", transform: "translateX(-50%)" }}>75</YStyled.Span>
          <YStyled.Span size={12} color="#71532D" fontFamily="SF Pro" className={style.tipNumber} style={{ left: "100%", transform: "translateX(-100%)" }}>100</YStyled.Span>
          <img src="./assets/ui/star.png" style={{ left: `${breath}%` }} />
        </div>
        <YStyled.Span className={style.title} size={15} fontWeight={400} color="#71532d">{`呼吸值 ${breath}`}</YStyled.Span>
      </div> */}

      <YStyled.Row align="space-around" style={{ width: "100%", margin: "1rem 0" }}>
        <YStyled.Col gap=".2rem" style={{ width: "auto", alignItems: "center", position: "relative", cursor: "pointer" }} onClick={e => {
          addModalType({
            cls: "Invatation", arg: {
              invitations: invitations
            }
          });
        }}>
          <img src="./assets/ui/mail.svg" />
          <YStyled.Span color="#71532D" size={13}>邀請</YStyled.Span>
          {invitations.length > 0 &&
            <div className={style.redPoint} style={{ top: "-4px", right: "-6px" }}></div>
          }
        </YStyled.Col>
        <YStyled.Col gap=".2rem" style={{ width: "auto", alignItems: "center", cursor: "pointer",opacity:.5 }} onClick={e => {
          //addModalType({ cls: "Statistics" });
        }}>
          <img src="./assets/ui/statistics.svg" />
          <YStyled.Span color="#71532D" size={13}>統計</YStyled.Span>
        </YStyled.Col>
        <YStyled.Col gap=".2rem" style={{ width: "auto", alignItems: "center", cursor: "pointer" }} onClick={e => {
          addModalType({ cls: "FriendList" });
        }}>
          <img src="./assets/ui/friend.svg" />
          <YStyled.Span color="#71532D" size={13}>朋友</YStyled.Span>
        </YStyled.Col>
        <YStyled.Col gap=".2rem" style={{ width: "auto", alignItems: "center", cursor: "pointer",opacity:.5 }} onClick={e => {
          //addModalType({ cls: "Coupon" });
        }}>
          <img src="./assets/ui/Ticket.svg" />
          <YStyled.Span color="#71532D" size={13}>優惠券</YStyled.Span>
        </YStyled.Col>
      </YStyled.Row>
      {/* <YStyled.Span size={15} color="#71532D" style={{ alignSelf: "flex-start", margin: "1rem 0" }}>我的成就</YStyled.Span>
      <div className={style.achievements}>
        {
          badges.filter(v => v.type === 1).map((v, k) => {
            return <div key={k} className={style.item} onClick={e => { set_currentVo(v) }}>
              <img src={`./assets/rewild/${v.id}.png`} />
            </div>
          })
        }
      </div>
      <YStyled.Span size={15} color="#71532D" style={{ alignSelf: "flex-start", margin: "1rem 0" }}>我的足跡</YStyled.Span>
      <div className={style.achievements}>
        {
          badges.filter(v => v.type === 2).map((v, k) => {
            return <div key={k} className={style.item} onClick={e => { set_currentVo(v) }}>
              <img src={`./assets/rewild/${v.id}.png`} />
            </div>
          })
        }
      </div>
      <YStyled.Span size={15} color="#71532D" style={{ alignSelf: "flex-start", margin: "1rem 0" }}>本月挑戰</YStyled.Span>
      <div className={style.achievements}>
        {
          badges.filter(v => v.type === 3).map((v, k) => {
            return <div key={k} className={style.item} onClick={e => { set_currentVo(v) }}>
              <img src={`./assets/rewild/${v.id}.png`} />
            </div>
          })
        }
      </div> */}
      {currentVo &&
        <div className={style.achievementDetail}>
          <img src={`./assets/rewild/${currentVo.id}.png`} />
          <div className={style.infoBox}>

            {currentVo.type === 1 &&
              <>
                <YStyled.Span size={17}>{currentVo.name}</YStyled.Span>
                <YStyled.Span size={15} fontWeight={400}>{currentVo.info}</YStyled.Span>
              </>
            }
            {currentVo.type === 2 &&
              <>
                <YStyled.Span size={17}>{currentVo.info}</YStyled.Span>
                <YStyled.Span size={28} fontWeight={400}>{currentVo.times}</YStyled.Span>
              </>
            }
            {currentVo.type === 3 &&
              <>
                <YStyled.Span size={17}>{currentVo.name}</YStyled.Span>
                <YStyled.Span size={15} fontWeight={400}>{currentVo.info}</YStyled.Span>
                <YStyled.Span size={15} fontWeight={300}>x {currentVo.times}</YStyled.Span>
              </>
            }
          </div>
          <img src="./assets/ui/x.svg" className={style.closeBtn} onClick={e => {
            set_currentVo(null)
          }} />
        </div>
      }
    </div>
  );
}

export default Tab4;